import { Box, Button, Typography } from '@mui/material';

import { styled } from '@mui/material/styles';
import { colors, themePalette } from '../../../../components/ThemeProvider/themeColors';

interface SalaryCardItemProps {
  title: string;
  description: string;
  applyButtonText: string;
  productTypes: Array<{
    title: string;
    value: string;
    icon: React.ReactNode;
    isHighlighted?: boolean;
  }>;
  onApply: () => void;
}

const SalaryCardItem = ({
  title,
  description,
  applyButtonText,
  productTypes,
  onApply,
}: SalaryCardItemProps) => {
  return (
    <CardContainer>
      {/* Image Section */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'absolute',
          bottom: { xs: 8, md: -12 },
          right: { xs: 8, md: 20 },
          pointerEvents: 'none',
        }}
      >
        <img
          src='/images/yelo_light-visa (1) 2.svg'
          alt='Guarantee'
          style={{ width: '100%', maxWidth: '220px' }}
        />
      </Box>

      {/* Content Section */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          width: '100%',
          pr: { md: '200px' },
        }}
      >
        {/* Title and Description */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography
            sx={{
              fontSize: '24px',
              fontWeight: 600,
              lineHeight: '30px',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '24px',
              color: themePalette.text_and_icon.third_party,
            }}
          >
            {description}
          </Typography>
        </Box>

        {/* Info Items */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: { xs: 2, md: 3 },
            alignItems: 'flex-start',
            '@media (min-width: 1400px)': {
              flexWrap: 'nowrap',
            },
          }}
        >
          {productTypes?.map((item, index) => {
            return (
              <Box
                key={index}
                sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', minWidth: 0 }}
              >
                {item.icon}

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: '16px',
                      fontWeight: 600,
                      lineHeight: '24px',
                      color: item.isHighlighted
                        ? colors.success[600]
                        : themePalette.text_and_icon.primary,
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '16px',
                      fontWeight: 400,
                      lineHeight: '24px',
                      color: themePalette.text_and_icon.third_party,
                    }}
                  >
                    {item.value}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* Buttons Section */}
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          onClick={onApply}
          sx={{
            height: '56px',
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          {applyButtonText}
        </Button>
      </Box>
    </CardContainer>
  );
};

const CardContainer = styled('div')({
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: 32,
  display: 'flex',
  flexDirection: 'column',
  gap: 32,
  position: 'relative',
  overflow: 'hidden',
  '@media (max-width: 900px)': {
    padding: 16,
    gap: 20,
  },
});

export default SalaryCardItem;
